module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-ThinItalic.e0a60ce.woff";